export const JACK_BARRY = 'Jack Barry';
export const BY_JACK_BARRY = 'by Jack Barry';
export const SITE_TITLE_PREFIX = JACK_BARRY + ' | ';
